import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IEmployee from '../../interfaces/IEmployee';

const useEmployeeService = () => {
  const request = useRequest<IEmployee>();
  const path = 'employee';

  const listByCpfAndBirthday = async (employee: IEmployee): Promise<IEmployee> => {
    return await request
      .post({ path: `${path}/cpf-birthday`, body: employee, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listById = async (id: number): Promise<IEmployee> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listForMedicalCertificateSearch = async (
    filter: string,
    companyId?: string | undefined,
  ): Promise<IEmployee[]> => {
    const sanitizedFilter = filter === '' ? ' ' : filter;

    let params = `perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter=${sanitizedFilter}`;

    if (companyId) {
      params += `&companyId=${companyId}`;
    }

    const url = `${path}/search?${params}`;

    return await request
      .getManyPaginated({
        path: url,
        sendAuthorization: true,
      })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { listByCpfAndBirthday, listForMedicalCertificateSearch, listById };
};

export { useEmployeeService };
